// The writing screen's floor (docs/21 §7): a World entered for its intro opens on the writing screen
// for at least WRITING_MIN_MS, even when its story was written ahead and is already told, so starting
// a World reads as one flow: writing → intro → first battle → Spoils → epilogue → World. Client-only
// and per session (device clock): a reload shows the screen again.
import { create } from 'zustand';
import { deviceNow } from '../time';

export const WRITING_MIN_MS = 5_000;

interface WritingStore { since: Record<string, number>; begin(worldId: bigint): void }

export const useWriting = create<WritingStore>()((set, get) => ({
  since: {},
  begin(worldId) { const k = worldId.toString(); if (get().since[k] === undefined) set({ since: { ...get().since, [k]: deviceNow() } }); },
}));
